/**
* Hidden submit for Confirm page (to Complete page)
*/

const completeSubmit = () => {
  const hiddenBtn = document.querySelector('#form-complete-clicked') as HTMLInputElement;

  if (!hiddenBtn) {
    return;
  }

  const submitBtn = document.querySelector('#form-submit-btn');
  submitBtn?.addEventListener('click', () => {
    hiddenBtn.value = '1';
  })
}

export default completeSubmit